import { render, staticRenderFns } from "./templateData.vue?vue&type=template&id=441c528c&scoped=true&"
import script from "./templateData.vue?vue&type=script&lang=js&"
export * from "./templateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c528c",
  null
  
)

export default component.exports